import React, {useContext} from 'react'
import styled from 'styled-components'
import ButtonPrevnextAtom from '../button_prevnext/button_prevnext.atom'
import StackAtom from '../../to_layout/stack/stack.atom'
import date_navStyles from './date_nav.styles'
import TypographyAtom from '../../to_content/typography/typography.atom'
import {StateComponentWeek} from '../../../@b_components/date_time_choice/date_time_choice.component'

const StyleWrapper = styled.div`
  ${date_navStyles}
`

const DateNavAtom = function () {
  const scweek = useContext(StateComponentWeek)
  // access contexted variables for date and time
  const {weekNow, weekPrevFn, weekNextFn} = scweek
  const byQty = 1
  return (
    <StyleWrapper>
      <StackAtom ap_type="row">
        <ButtonPrevnextAtom
          ap_type="prev"
          onClick={() => weekPrevFn(weekNow)}
        />
        <div>
          <TypographyAtom ahd_type="subheading">
            <span>{`${weekNow.startOf('week').minus({days: byQty}).day} ${
              weekNow.startOf('week').minus({days: byQty}).monthShort
            }`}</span>
            <span className="gap">-</span>
            <span>{`${weekNow.endOf('week').minus({days: byQty}).day} ${
              weekNow.endOf('week').minus({days: byQty}).monthShort
            }`}</span>
          </TypographyAtom>
        </div>

        <ButtonPrevnextAtom
          ap_type="next"
          onClick={() => weekNextFn(weekNow)}
        />
      </StackAtom>
    </StyleWrapper>
  )
}

export default DateNavAtom
